import { render, staticRenderFns } from "./CompetitionStatsWidget.vue?vue&type=template&id=bdb8012a&scoped=true"
import script from "./CompetitionStatsWidget.vue?vue&type=script&lang=js"
export * from "./CompetitionStatsWidget.vue?vue&type=script&lang=js"
import style0 from "./CompetitionStatsWidget.vue?vue&type=style&index=0&id=bdb8012a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb8012a",
  null
  
)

export default component.exports